import { ThirdPartyLogisticsApiClient } from '@fourthwall/services/dist/ThirdPartyLogisticsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useThirdPartyLogisticsOptionsQuery = createQueryHook(
  ThirdPartyLogisticsApiClient.getShippingPackagePricingOptions,
  {
    queryKey: ['thirdPartyLogisticsOptions'],
  },
)
